/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ConfigSummary_ConfigFragment = { __typename: 'ConfigurationModel', id: string, name: string, shouldUpdateToLatestFirmware?: boolean | null, createdAt: any, platform: string, description?: string | null, updatedAt?: any | null, publisherUserName?: string | null, firmware?: { __typename: 'ConfigFirmware', android: { __typename: 'ConfigAndroid', version: any }, scaler?: { __typename: 'ConfigScaler', version: any } | null } | null, configStatistics: { __typename: 'ConfigStatistics', assignedDisplays: number, inSyncDisplays: number, outOfSyncDisplays: number, syncingDisplays: number } };

export const ConfigSummary_ConfigFragmentDoc = gql`
    fragment ConfigSummary_config on ConfigurationModel {
  id
  name
  firmware {
    android {
      version
    }
    scaler {
      version
    }
  }
  shouldUpdateToLatestFirmware
  createdAt
  platform
  description
  updatedAt
  publisherUserName
  configStatistics {
    assignedDisplays
    inSyncDisplays
    outOfSyncDisplays
    syncingDisplays
  }
}
    `;